/* eslint-disable @typescript-eslint/no-unused-vars */
import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import {
  IUseRoutermailPageSearchQuery,
  ComposeModal,
} from 'src/hooks/router/useRouterMail'

export const sendEmailTool = createTool({
  id: 'send-email',
  description:
    'Send an email to a contact. Use this when user wants to send an email or when suggesting to send an email message.',
  inputSchema: z.object({
    email: z.string().email().describe('Recipient email'),
    subject: z.string().describe('Subject line'),
    messageText: z.string().describe('Email body'),
    objectSchemeIdentifier: z
      .string()
      .optional()
      .describe('Related CRM object scheme'),
    objectUniqId: z.string().optional().describe('Related CRM object UUID'),
    parentSchemeIdentifier: z
      .string()
      .optional()
      .describe('Parent object scheme'),
    parentUniqId: z.string().optional().describe('Parent object UUID'),
    skipConfirmation: z
      .boolean()
      .optional()
      .default(false)
      .describe('Skip confirmation dialog'),
  }),
  execute: async (context: any) => {
    const { email, subject, messageText } = context
    const skipConfirmation = false

    const querySearch: IUseRoutermailPageSearchQuery & { modal?: string } = {
      modal: ComposeModal,
      mailPage: {
        composeParams: {
          // emailId?: number
          addresseParams: {
            // storageObjects?: IListItem[]
            values: [email],
          },
          // scheme?: string
          subject: subject,
          contentInsert: messageText,
        },
      },
    }
    store.dispatch(
      appActions.navigate({
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `${
        skipConfirmation ? 'Sending' : 'Preparing to send'
      } email to ${email}`,
    }
  },
})
